module.exports = {
  "country": "GE",
  "artist": "Nika Koscharow & Young Georgian Lolitaz",
  "song": "Midnight Gold",
  "year": "2016",
  "place": "20",
  "spotify": ""
};